// Copyright (c) 2016 Deere & Company

import Currency, {getDefaultState as getCurrencyDefaultState} from './currency';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import Measurement, {getDefaultState as getMeasurementDefaultState} from './measurement';
import UseAmount, {getDefaultState as getUseAmountDefaultState} from './use-amount';
import WarrantyBeginMeasurement, {getDefaultState as getWarrantyBeginMeasurementDefaultState} from './warranty-begin-measurement';

import t from 'tcomb';

const Warranty = t.struct({
    contractPurchaseDate: t.maybe(t.Number),
    contractTypeIndicator: t.String,
    coverageInMonths: t.maybe(t.Number),
    daysRemaining: t.maybe(t.Number),
    deductible: Currency,
    deductibleApplies: t.Boolean,
    diagnosticsCovered: t.Boolean,
    distanceLimit: Measurement,
    expireDate: t.maybe(t.Number),
    fluidSamplingRequired: t.Boolean,
    id: t.String,
    isExpired: t.Boolean,
    jDProtectInspection: t.Boolean,
    jDProtectMCon: t.Boolean,
    laborApplies: t.Boolean,
    planName: t.String,
    startDate: t.maybe(t.Number),
    supplierWarranty: t.Boolean,
    suspended: t.Boolean,
    timeLimit: Measurement,
    uptimeAssurance: UseAmount,
    warrantyBeginMeasurement: WarrantyBeginMeasurement,
    warrantyItemText: t.String,
    warrantyType: KeyValuePair,
    wearPartCoverage: UseAmount,
    winterizationCov: t.Boolean
}, {
    name: 'Warranty',
    strict: true
});

export const getDefaultState = () => new Warranty({
    contractPurchaseDate: null,
    contractTypeIndicator: '',
    coverageInMonths: null,
    daysRemaining: null,
    deductible: getCurrencyDefaultState(),
    deductibleApplies: false,
    diagnosticsCovered: false,
    distanceLimit: getMeasurementDefaultState(),
    expireDate: null,
    fluidSamplingRequired: false,
    id: '',
    isExpired: false,
    jDProtectInspection: false,
    jDProtectMCon: false,
    laborApplies: false,
    planName: '',
    startDate: null,
    supplierWarranty: false,
    suspended: false,
    timeLimit: getMeasurementDefaultState(),
    uptimeAssurance: getUseAmountDefaultState(),
    warrantyBeginMeasurement: getWarrantyBeginMeasurementDefaultState(),
    warrantyItemText: '',
    warrantyType: getKeyValuePairDefaultState(),
    wearPartCoverage: getUseAmountDefaultState(),
    winterizationCov: false
});

export default Warranty;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/warranty.js